import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    getEmploiInformationInscriptionRequest: ['response'],
    getEmploiInformationInscriptionSuccess: ['response', 'loading'],
    getEmploiInformationInscriptionFailure: ['error'],
})

export const getEmploiInformationInscriptionTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const getEmploiInformationInscriptionSuccess = (state, { response }) =>
    state.merge({
        error: false,
        response,
        loading: false,
    })
const getEmploiInformationInscriptionFailure = (state, { error }) =>
    state.merge({
        loading: false,
        error,
    })
const getEmploiInformationInscriptionRequest = state =>
    state.merge({ loading: true, error: null })

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_EMPLOI_INFORMATION_INSCRIPTION_REQUEST]: getEmploiInformationInscriptionRequest,
    [Types.GET_EMPLOI_INFORMATION_INSCRIPTION_SUCCESS]: getEmploiInformationInscriptionSuccess,
    [Types.GET_EMPLOI_INFORMATION_INSCRIPTION_FAILURE]: getEmploiInformationInscriptionFailure,
})
